export async function computeItemHash(itemText: string | null, itemJson: string): Promise<string> {
  const content = itemText ?? itemJson;
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(content));
  return [...new Uint8Array(buf)].map(b => b.toString(16).padStart(2, '0')).join('');
}

export function isValidItemHash(hash: string): boolean {
  return /^[a-f0-9]{64}$/.test(hash);
}
